// i18n — IKKI QATLAMNING BIRINCHISI (xsib-selfcare/xsib-admin naqshi bilan
// bir xil). Bu yerda faqat BIZNING matnlarimiz tarjima qilinadi. antd
// komponentlarining ichki matnlari alohida qatlam — `antdLocales.ts`.
//
// ⚠️ STANDART TIL — 'en' (egasi qarori, 2026-08-08; ilgari 'uz' edi).
// Uch ilovada ham bir xil.
//
// Mehmon tilni o'zi tanlashi mumkin (`shared/ui/LanguageSwitcher.tsx`),
// lekin tanlov SAQLANMAYDI va bu ataylab: bu bir martalik, anonim
// sahifa. Tilni `localStorage` da saqlash mehmonning qurilmasini
// identifikatsiya qiladigan qo'shimcha iz qoldirardi, vazifa esa aynan
// buni cheklaydi ("telefon raqamini localStorage'ga saqlama"). Til
// tanlovi sezgir emas, lekin ehtiyot choralari bir xil bo'lsin — u
// react state ichida qoladi va sahifa yangilanganda standartga
// qaytadi.
//
// ⚠️ Shu sababli bu yerdagi standart boshqa ikki ilovadagidan
// KO'PROQ ahamiyatli: mehmon uni deyarli har doim ko'radi.

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'
import fa from './fa.json'
import ru from './ru.json'
import uz from './uz.json'

export const SUPPORTED_LANGUAGES = ['en', 'ru', 'uz', 'fa'] as const
export type Language = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: Language = 'en'

/** Intl uchun to'liq locale kodlari — sana, raqam va bayt formatlash shu bo'yicha */
export const INTL_LOCALES: Record<Language, string> = {
  en: 'en-US',
  ru: 'ru-RU',
  uz: 'uz-UZ',
  // ⚠️ Kengaytmalarsiz `fa-AF` forscha raqam (۱۲۳) va quyosh hijriy
  // taqvimini beradi — ikkalasi ham bu yerda kerak emas.
  fa: 'fa-AF-u-ca-gregory-nu-latn',
}

function isLanguage(value: string): value is Language {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(value)
}

/** Joriy tilni `Language` turiga keltiradi */
export function currentLanguage(): Language {
  const lang = i18n.resolvedLanguage ?? i18n.language ?? DEFAULT_LANGUAGE
  const base = lang.split('-')[0] ?? DEFAULT_LANGUAGE
  return isLanguage(base) ? base : DEFAULT_LANGUAGE
}

// Ro'yxat ataylab — keyin pushtu ('ps') qo'shilsa bitta satr yetadi.
export const RTL_LANGUAGES: readonly Language[] = ['fa']

export function isRtl(lang: Language = currentLanguage()): boolean {
  return RTL_LANGUAGES.includes(lang)
}

// antd `ConfigProvider direction` dan oladi, CSS va brauzer esa `<html dir>`
// dan — ikkalasi qo'yilmasa panel yarim o'girilgan qoladi.
function applyDirection(lang: Language): void {
  document.documentElement.dir = isRtl(lang) ? 'rtl' : 'ltr'
}

/** Joriy til uchun Intl locale kodi */
export function currentIntlLocale(): string {
  return INTL_LOCALES[currentLanguage()]
}

export function changeLanguage(lang: Language): void {
  void i18n.changeLanguage(lang)
  document.documentElement.lang = lang
  applyDirection(lang)
}

// Brauzer tilidan boshlang'ich taxmin (mehmon ilgari shu tilni ochgan
// bo'lishi mumkin), lekin saqlanmaydi va aniq qo'llab-quvvatlanmasa 'uz'ga
// tushadi.
function detectInitialLanguage(): Language {
  if (typeof navigator === 'undefined') return DEFAULT_LANGUAGE
  const base = navigator.language?.split('-')[0]
  return base && isLanguage(base) ? base : DEFAULT_LANGUAGE
}

const initialLanguage = detectInitialLanguage()

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fa: { translation: fa },
    ru: { translation: ru },
    uz: { translation: uz },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: [...SUPPORTED_LANGUAGES],
  interpolation: {
    escapeValue: false, // React o'zi ekranlaydi
  },
  returnNull: false,
})

document.documentElement.lang = initialLanguage
applyDirection(initialLanguage)

export default i18n
